import { render, staticRenderFns } from "./UploadDefault.vue?vue&type=template&id=68e70cf8&scoped=true&"
import script from "./UploadDefault.vue?vue&type=script&lang=js&"
export * from "./UploadDefault.vue?vue&type=script&lang=js&"
import style0 from "./UploadDefault.vue?vue&type=style&index=0&id=68e70cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e70cf8",
  null
  
)

export default component.exports